import { DocumentationItemHeaderV2 } from "@supernova-studio/model";
import { z } from "zod";
export const DTODocumentationItemHeaderV2 = DocumentationItemHeaderV2;
export const DTODocumentationItemConfigurationV2 = z.object({
    showSidebar: z.boolean(),
    isPrivate: z.boolean(),
    isHidden: z.boolean(),
    header: DTODocumentationItemHeaderV2,
});
